import {
    tss,
} from 'app/tss'

export default tss.create({
    gridWrapper: {
        display: 'block',
    },
})
